import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import FeaturedArticlesTable from './Table';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class FeaturedArticlesView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            articles: [],
            articleQueryObject: {
                limit: 'none',
                featured: true,
                sort: 'featured',
            },
        };
    }
    componentDidMount() {
        this.loadArticles();
    }
    loadArticles = () => {
        return this.props.getArticles( this.state.articleQueryObject )
        .then( ( articles ) => {
            this.setState( ( altState ) => {
                altState.fetching= false,
                altState.articles = altState.articles.concat( articles ),
                altState.articleQueryObject.page++;
                return altState;
            } );
            return articles;
        } );
    }
    articleUpdated = ( index, article ) => {
        this.setState( ( altState ) => {
            if( article.featured == null ) {
                altState.articles.splice( index, 1 );
            } else {
                altState.articles[ index ] = article;
            }
            altState.articles = altState.articles.slice( 0 );
            return altState;
        } );
    }
    onManualSort = ( order, s, evt ) => {
        this.setState( ( altState ) => {
            var movedArticle = altState.articles.splice( evt.oldIndex, 1 )[ 0 ];
            altState.articles.splice( evt.newIndex, 0, movedArticle );
            altState.articles = altState.articles.slice( 0 );
            var orderedArticleIds = altState.articles.map( article => article.id );
            this.props.updateFeaturedArticleOrder( orderedArticleIds );
            return altState;
        } );
    }



    render() {
        const { fetching, articles } = this.state;

        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Articles</h2>
                    <div className={ style.controls }>
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/content' className={ style.tabOption }>View All</Link>
                        <Link to='/admin/content/featured' className={ style.tabOption }
                        data-active={ true }>Featured Articles</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.featuredArticles }>
                        <div className={ style.filters }></div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <FeaturedArticlesTable articles={ articles }
                            onArticleUpdated={ this.articleUpdated }
                            onSort={ this.onManualSort } />
                        }
                    </section>
                </div>
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getArticles: ( queryObject ) => {
            return dAPI.get( '/admin/content', queryObject );

        },
        updateFeaturedArticleOrder: ( newOrder ) => {
            return dAPI.patch( '/admin/curated-articles/orderFeatured', { orderedArticleIds: newOrder } );

        },
    };
};

export default connect( null, mapDispatchToProps )( FeaturedArticlesView );
